<template>
  <i class="jin-icon" :class="[`jin-icon-${name}`]" :style="{'color': color}" @click="onClick" />
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
    // size: {
    //   type: [String, Number]
    // }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

